export const probabilityCallback = (chance: number, callback: () => any) : void => {
    const x = Math.random();
    if (x <= chance) {
        callback()
    }
}
